const { RangeControl } = wp.components;
const { Component } = wp.element;



const CarSpeed = (props) => {
		
	const { attributes, setAttributes } = props;
	
	const marks = [
		{
			value: 0,
			label: ".5s"
		},
		{
			value: 19,
			label: '10s'
		}
	];	
	
	const CurrentSpeed = value => `${value}s`
	
	return (
		<p>
			<RangeControl
				label="Speed"
				value={ attributes.speed }
				onChange={ ( newSpeed ) => setAttributes( { speed: newSpeed } ) }
				marks={ marks }
				min={ .5}
				step={ .5 }
				max={ 10 }
				withInputField={ false }
				renderTooltipContent={ CurrentSpeed }
			/>
		</p>
	)
}

export default CarSpeed;